import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useActivateUser } from "../hooks/useIdentityMutations";

export default function IdentityActivate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");
  const hasTriggered = useRef(false);

  const { mutate } = useActivateUser(
    () => {
      setStatus("success");
      setTimeout(() => {
        navigate("/auth/login", { replace: true });
      }, 5000);
    },
    (activateError) => {
      setStatus("error");
      setError(activateError?.message || "Activation failed");
    },
    true,
  );

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Missing activation token");
      return;
    }

    if (hasTriggered.current) return;
    hasTriggered.current = true;
    mutate(token);
  }, [token, mutate]);

  if (status === "loading") {
    return <div>Activating account...</div>;
  }

  if (status === "error") {
    return <div>{error}</div>;
  }

  return <div>Account activated successfully. Redirecting to login in 5 seconds...</div>;
}
